export const onlyNumbers = (inputString: string) => {
  const regexPattern = /[^0-9,.]/g;
  return inputString.replace(regexPattern, '');
};

export const safeParseStringArray = (input: string): string[] => {
  try {
    const parsed = JSON.parse(input.replaceAll("'", '"'));

    if (
      Array.isArray(parsed) &&
      parsed.every((item) => typeof item === 'string')
    ) {
      return parsed;
    }

    return [];
  } catch {
    return [];
  }
};

export const replaceComma = (value: string) => value.replace(',', '.');

export const searchText = (haystack?: string, needle?: string) => {
  if (!haystack || !needle) return true;

  return haystack.toLowerCase().includes(needle.toLowerCase());
};
